var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap',{attrs:{"containerHeight":(_vm.container_height + "px"),"height":(_vm.container_height + "px"),"center":_vm.mapCenter,"markerIconOptions":{
    size: 20,
    url: _vm.getIcon(),
  },"zoom":15,"options":_vm.options},on:{"mapReady":_vm.handleMapReady,"showEditMapModal":_vm.showEditMapModal}})}
var staticRenderFns = []

export { render, staticRenderFns }